import { render, staticRenderFns } from "./RegisterCheck.vue?vue&type=template&id=63a5ea56&scoped=true&"
import script from "./RegisterCheck.vue?vue&type=script&lang=js&"
export * from "./RegisterCheck.vue?vue&type=script&lang=js&"
import style0 from "./RegisterCheck.vue?vue&type=style&index=0&id=63a5ea56&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63a5ea56",
  null
  
)

export default component.exports